import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';

import { WithAuditService } from '@app/assets/common/audit.service';
import type { ReportDto } from '@app/assets/report/report.dto';
import { REPORTS_PATH } from '@app/shared/api/api-route.config';
import { WithCrudService } from '@app/shared/api/crud.service';
import { WithExportableService } from '@app/shared/api/export.service';
import { RestService } from '@app/shared/api/rest.service';
import { WithWorkflowableService } from '@app/shared/approval/workflow.service';
import { WithLogService } from '@app/shared/change-log/log.service';
import { WithCrudVersionService } from '@app/shared/change-log/version.service';
import { WithJobService } from '@app/shared/job-history/job.service';
import { WithLineageService } from '@app/shared/lineage/lineage.service';

@Injectable({
    providedIn: 'root',
})
export class ReportsService extends classes(
    WithCrudVersionService<ReportDto>,
    WithCrudService<ReportDto>,
    WithAuditService,
    WithWorkflowableService,
    WithLineageService,
    WithLogService,
    WithExportableService,
    WithJobService,
) {
    protected endpoint = REPORTS_PATH;

    protected readonly api = inject(RestService);
}
